import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class PlateService {
  constructor(private http: HttpClientService) {}

  public getPlate(account_id): Observable<any[]> {
    return this.http
      .get(`/api/accounts/${account_id}/plates`)
      .pipe(tap((_) => console.log("PlateService.getPlate: Ok.")));
  }

  public getAllPlates(filters): Observable<any> {
    const options = {
      params: filters,
    };
    return this.http.get("/api/plates/all", options).pipe(tap((_) => console.log("PlateService.getAllPlate: Ok.")));
  }
  public addPlate(account_id, plate): Observable<any> {
    const options = {
      plate,
    };
    return this.http
      .post(`/api/accounts/${account_id}/plates`, options)
      .pipe(tap((_) => console.log("PlateService.addPlate: Ok.")));
  }
  public updatePlate(plate): Observable<any> {
    const options = {
      plate,
    };
    return this.http
      .put(`/api/plates/${plate.id}`, options)
      .pipe(tap((_) => console.log("PlateService.updatePlate: Ok.")));
  }
  public processDebtsData(content): Observable<any> {
    return this.http
      .post("/api/plates/process_data", { content })
      .pipe(tap((_) => console.log("PlateService.processDebtsData: Ok.")));
  }
}
